// ライブラリ
import polyfill from './inc/polyfill.js';

// ポリフィル
polyfill();

// 関数群
import EnvDetector from './inc/EnvDetector.js';
// import webFont from './inc/webFont.js';

// スマホでホバー機能を有効化するスクリプトを使うとtarget blankやdownload属性が効かなくなるので無効化している
// import touchDevice from './inc/touchDevice.js';
// import mainVisual from './inc/mainVisual.js';
// import swiperjs from './inc/swiper.js';
import CustomPropertyManager from './inc/customPropertyManager.js';
// import MenuManager from './inc/MenuManager.js';
// import hideOnScroll from './inc/HideOnScroll.js';

// IEを判定してbodyタグにclass付与
new EnvDetector();

// スムーススクロール機能
// smoothScroll();

// Web Font Loader
// TODO: 不要か判断して削除する
// webFont();

// Scroll Magicによるスクロール管理
import ScrollManager from './inc/ScrollManager.js';
new ScrollManager();

// Swiperによるスライダー管理
// import SliderManager from './inc/SliderManager.js';
// new SliderManager();

// タッチデバイス対応（ホバー挙動の再現など）
// touchDevice();

// メインビジュアル動画
// mainVisual();
// CSSのカスタムプロパティを管理
new CustomPropertyManager();

// メニュー管理（ハンバーガーメニュー、モーダル）
// new MenuManager();

// 要素をスクロール時に隠す
// new hideOnScroll();

// import TabManager from './inc/TabManager.js';
// new TabManager();

// 開発用の機能郡（本番公開時に削除する）
// import DevUtils from './inc/DevUtils.js';
// new DevUtils();
